import React from "react";
import CMSlist from "../pages/cms-pages/CMSlist";
import { lazy } from "react";
import DiscountList from "../pages/product-management/Discounts/List";
import DiscountAdd from "../pages/product-management/Discounts/Add";
import DiscountEdit from "../pages/product-management/Discounts/Edit";
import AffirmCheckout from "../pages/AffirmCheckout";

const ForgotPassword = lazy(() => import("../pages/forgot-password"));
const Login = lazy(() => import("../pages/login"));
const LoginOld = lazy(() => import("../pages/login_old"));
const PasswordReset = lazy(() => import("../pages/password-reset"));
const CreatePassword = lazy(() => import("../pages/create-password"));
const Users = lazy(() => import("../pages/user-management/admin-user/list"));
const AddUser = lazy(() => import("../pages/user-management/admin-user/add"));
const AccessManagement = lazy(() => import("../pages/access-management/list"));
const EmailTemplate = lazy(() => import("../pages/email-template/list"));
const UpdateProfile = lazy(() => import("../pages/user-profile/update"));
const Customers = lazy(() => import("../pages/user-management/customer/list"));
const ViewCustomer = lazy(
  () => import("../pages/user-management/customer/view"),
);
const AddCustomer = lazy(() => import("../pages/user-management/customer/add"));
const ReactiveAccount = lazy(() => import("../pages/reactive-account"));

const ProductsReviews = lazy(
  () => import("../pages/product-management/reviews/list"),
);
const ViewReview = lazy(
  () => import("../pages/product-management/reviews/view"),
);
const ProductCategory = lazy(
  () => import("../pages/product-management/product-category/list"),
);
const AddCategory = lazy(
  () => import("../pages/product-management/product-category/add"),
);
const ProductCollection = lazy(
  () => import("../pages/product-management/product-collection/list"),
);
const AddCollection = lazy(
  () => import("../pages/product-management/product-collection/add"),
);
const Products = lazy(() => import("../pages/product-management/product/list"));
const AddProduct = lazy(
  () => import("../pages/product-management/product/add"),
);
const EditHeader = lazy(() => import("../CMS/header/Edit"));
const EditFooter = lazy(() => import("../CMS/footer/Edit"));
const EditProductPage = lazy(() => import("../CMS/product/Edit"));
const EditCategoriesPage = lazy(() => import("../CMS/categories/Edit"));
const EditCMSPage = lazy(() => import("../CMS/pages/Edit"));
const EditCMSBlogPage = lazy(() => import("../CMS/blog-pages/Edit"));
const EditSystemPage = lazy(() => import("../CMS/system-pages/Edit"));
const ComponentsTab = lazy(() => import("../pages/cms-pages/ComponentsTab"));
const ProductBrand = lazy(
  () => import("../pages/product-management/product-brand/list"),
);
const AddBrand = lazy(
  () => import("../pages/product-management/product-brand/add"),
);
const ViewBrand = lazy(
  () => import("../pages/product-management/product-brand/view"),
);
const HeaderSetting = lazy(
  () => import("../pages/setting/header-setting/list"),
);
const ProductCompatibility = lazy(
  () => import("../pages/product-management/compatibility/list"),
);
const AddCompatibility = lazy(
  () => import("../pages/product-management/compatibility/add"),
);

const AbandonedCheckouts = lazy(
  () => import("../pages/orders-management/abandoned-checkouts/list"),
);

const ViewCheckout = lazy(
  () => import("../pages/orders-management/abandoned-checkouts/view"),
);

const Orders = lazy(() => import("../pages/orders-management/orders/list"));
const AddOrder = lazy(() => import("../pages/orders-management/orders/add"));
const ViewOrder = lazy(() => import("../pages/orders-management/orders/view"));
const EditOrder = lazy(() => import("../pages/orders-management/orders/add"));

const AddStore = lazy(() => import("../pages/store/store-address/add"));
const AddShipStation = lazy(
  () => import("../pages/store/shipstation-shipping/add"),
);
const AddVendor = lazy(() => import("../pages/purchase/vendor/add"));
const Vendor = lazy(() => import("../pages/purchase/vendor/list"));
const ViewVendor = lazy(() => import("../pages/purchase/vendor/view"));
const SalesTeam = lazy(
  () => import("../pages/orders-management/sales-team/list"),
);

const OrderAddOn = lazy(
  () => import("../pages/orders-management/ordor-addon/list"),
);
const AddOrderAddOn = lazy(
  () => import("../pages/orders-management/ordor-addon/add"),
);
const Test = lazy(() => import("../pages/test"));

const AddGiftCardProduct = lazy(
  () => import("../pages/gift-card/gift-card-product/add"),
);

const GiftCardList = lazy(
  () => import("../pages/gift-card/gift-card-core/list"),
);
const AddGiftCard = lazy(() => import("../pages/gift-card/gift-card-core/add"));
const ViewGiftCard = lazy(
  () => import("../pages/gift-card/gift-card-core/view"),
);
const DuplicateProduct = lazy(
  () => import("../pages/product-management/duplicate-product/add"),
);

const Dashboard = lazy(() => import("../pages/dashboard/view"));
const CompatibilityReport = lazy(
  () => import("../pages/reports/compatibility/list"),
);
const Reports = lazy(() => import("../pages/reports/list"));
const EditPayments = lazy(() => import("../pages/store/payment-gateways/add"));
const EditRefundReasons = lazy(() => import("../pages/store/refund/reasons"));

const OrderReport = lazy(() => import("../pages/reports/orders/view"));

const Refunds = lazy(() => import("../pages/orders-management/refunds/list"));
const AddAttribute = lazy(
  () => import("../pages/product-management/product-attribute/add"),
);
const ProductAttribute = lazy(
  () => import("../pages/product-management/product-attribute/list"),
);

const ReturnOperationsDashboard = lazy(
  () => import("../pages/return-operations/dashboard"),
);
const ReturnOperationsReturnsList = lazy(
  () => import("../pages/return-operations/returns/list"),
);
const ReturnOperationsReturnView = lazy(
  () => import("../pages/return-operations/returns/view"),
);
const ReturnOperationsReceivesList = lazy(
  () => import("../pages/return-operations/receives/list"),
);
const ReturnOperationsReceiveView = lazy(
  () => import("../pages/return-operations/receives/view"),
);
const ReturnOperationsRefundSyncList = lazy(
  () => import("../pages/return-operations/refund-sync/list"),
);
const ReturnOperationsRefundSyncView = lazy(
  () => import("../pages/return-operations/refund-sync/view"),
);

const RepairOrdersDashboard = lazy(
  () => import("../pages/repair-orders/dashboard"),
);
const RepairOrdersList = lazy(
  () => import("../pages/repair-orders/orders/list"),
);
const RepairOrderView = lazy(
  () => import("../pages/repair-orders/orders/view"),
);
const RepairIncomingReceivesList = lazy(
  () => import("../pages/repair-orders/incoming-receives/list"),
);
const RepairIncomingReceiveView = lazy(
  () => import("../pages/repair-orders/incoming-receives/view"),
);
const RepairServiceOrdersList = lazy(
  () => import("../pages/repair-orders/service-orders/list"),
);
const RepairServiceOrderView = lazy(
  () => import("../pages/repair-orders/service-orders/view"),
);
const AddLoyaltyProgram = lazy(
  () => import("../pages/loyalty-program/program/add"),
);
const LoyaltyPrograms = lazy(
  () => import("../pages/loyalty-program/program/list"),
);
const AddLoyaltyPromotion = lazy(
  () => import("../pages/loyalty-program/promotion/add"),
);
const routes = {
  LOGIN: {
    path: "/login",
    component: Login,
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
    pageTitle: "Login",
  },
  LOGIN_OLD: {
    path: "/login-old",
    component: LoginOld,
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
    pageTitle: "Login Old",
  },
  DASHBOARD: {
    path: "/",
    component: Dashboard,
    withSidebar: true,
    pageTitle: "Dashboard",
  },
  RESET_PASSWORD: {
    path: "/password-reset",
    component: PasswordReset,
    withSidebar: false,
    requireLogin: false,
    pageTitle: "Reset Password",
  },
  CREATE_PASSWORD: {
    path: "/create-password",
    component: CreatePassword,
    withSidebar: false,
    requireLogin: false,
    pageTitle: "Create Password",
  },
  FORGOT_PASSWORD: {
    path: "/forgot-password",
    component: ForgotPassword,
    withSidebar: false,
    requireLogin: false,
    pageTitle: "Forgot Password",
  },
  REACTIVE_ACCOUNT: {
    path: "/reactive-account/:reactive_token",
    component: ReactiveAccount,
    withSidebar: false,
    requireLogin: false,
    pageTitle: "Reactive Account",
  },
  USERS: {
    path: "/users",
    component: Users,
    withSidebar: true,
    pageTitle: "Users",
  },
  ADD_USER: {
    path: "/add-user",
    component: AddUser,
    withSidebar: true,
    pageTitle: "Add User",
  },
  EDIT_USER: {
    path: "/edit-user/:id",
    component: AddUser,
    withSidebar: true,
    pageTitle: "Edit User",
  },
  ACCESS_MANAGEMENT: {
    path: "/roles-and-permissions",
    component: AccessManagement,
    withSidebar: true,
    pageTitle: "Access Control",
  },
  PROFILE_UPDATE: {
    path: "/update-profile",
    component: UpdateProfile,
    withSidebar: true,
    pageTitle: "Update Profile",
  },
  CUSTOMERS: {
    path: "/customers",
    component: Customers,
    withSidebar: true,
    pageTitle: "Customers",
  },
  ADD_CUSTOMER: {
    path: "/add-customer",
    component: AddCustomer,
    withSidebar: true,
    pageTitle: "Add Customer",
  },
  EDIT_CUSTOMER: {
    path: "/edit-customer/:id",
    component: AddCustomer,
    withSidebar: true,
    pageTitle: "Edit Customer",
  },
  VIEW_CUSTOMER: {
    path: "/view-customer/:id",
    component: ViewCustomer,
    withSidebar: true,
    pageTitle: "View Customer",
  },
  PRODUCTS: {
    path: "/products",
    component: Products,
    withSidebar: true,
    pageTitle: "Products",
  },
  ADD_PRODUCT: {
    path: "/add-product",
    component: AddProduct,
    withSidebar: true,
    pageTitle: "Add Product",
  },
  DUPLICATE_PRODUCT: {
    path: "/duplicate-product/:id",
    component: DuplicateProduct,
    withSidebar: true,
    pageTitle: "Duplicate Product",
  },
  ORDERS: {
    path: "/orders",
    component: Orders,
    withSidebar: true,
    pageTitle: "Orders",
  },
  ADD_ORDER: {
    path: "/add-order",
    component: AddOrder,
    withSidebar: true,
    pageTitle: "Add Orders",
  },
  EDIT_ORDER: {
    path: "/edit-order/:id",
    component: AddOrder,
    withSidebar: true,
    pageTitle: "Edit Orders",
  },
  VIEW_ORDER: {
    path: "/view-order/:id",
    component: ViewOrder,
    withSidebar: true,
    pageTitle: "View Order",
  },
  EDIT_PRODUCT: {
    path: "/edit-product/:id",
    component: AddProduct,
    withSidebar: true,
    pageTitle: "Edit Product",
  },
  PRODUCT_ATTRIBUTE: {
    path: "/product-attribute",
    component: ProductAttribute,
    withSidebar: true,
    pageTitle: "Product Attribute",
  },
  ADD_ATTRIBUTE: {
    path: "/add-attribute",
    component: AddAttribute,
    withSidebar: true,
    pageTitle: "Add Attribute",
  },
  EDIT_ATTRIBUTE: {
    path: "/edit-attribute/:id",
    component: AddAttribute,
    withSidebar: true,
    pageTitle: "Edit Attribute",
  },
  PRODUCT_CATEGORY: {
    path: "/product-category",
    component: ProductCategory,
    withSidebar: true,
    pageTitle: "Product Category",
  },
  ADD_CATEGORY: {
    path: "/add-category",
    component: AddCategory,
    withSidebar: true,
    pageTitle: "Add Category",
  },
  EDIT_CATEGORY: {
    path: "/edit-category/:id",
    component: AddCategory,
    withSidebar: true,
    pageTitle: "Edit Category",
  },
  PRODUCT_CATALOG: {
    path: "/product-catalog",
    component: ProductCollection,
    withSidebar: true,
    pageTitle: "Product Catalog",
  },
  ADD_COLLECTION: {
    path: "/add-catalog",
    component: AddCollection,
    withSidebar: true,
    pageTitle: "Add Catalog",
  },
  EDIT_COLLECTION: {
    path: "/edit-catalog/:id",
    component: AddCollection,
    withSidebar: true,
    pageTitle: "Edit Catalog",
  },
  PRODUCT_BRAND: {
    path: "/product-brand",
    component: ProductBrand,
    withSidebar: true,
    pageTitle: "Product Brand",
  },
  ADD_BRAND: {
    path: "/add-brand",
    component: AddBrand,
    withSidebar: true,
    pageTitle: "Add Brand",
  },
  EDIT_BRAND: {
    path: "/edit-brand/:id",
    component: AddBrand,
    withSidebar: true,
    pageTitle: "Edit Brand",
  },
  SHOW_BRAND: {
    path: "/view-brand/:id",
    component: ViewBrand,
    withSidebar: true,
    pageTitle: "Brand Details",
  },
  PRODUCT_COMPATIBILITY: {
    path: "/product-compatibility",
    component: ProductCompatibility,
    withSidebar: true,
    pageTitle: "Product Compatibility",
  },
  ADD_COMPATIBILITY: {
    path: "/add-compatibility",
    component: AddCompatibility,
    withSidebar: true,
    pageTitle: "Add Compatibility",
  },
  EDIT_COMPATIBILITY: {
    path: "/edit-compatibility/:id",
    component: AddCompatibility,
    withSidebar: true,
    pageTitle: "Edit Compatibility",
  },
  HEADER_SETTING: {
    path: "/settings",
    component: HeaderSetting,
    withSidebar: true,
    pageTitle: "Settings",
  },
  PRODUCTSREVIEWS: {
    path: "/products-reviews",
    component: ProductsReviews,
    withSidebar: true,
    pageTitle: "Products Reviews",
  },
  VIEW_PRODUCTREVIEW: {
    path: "/view-review/:id",
    component: ViewReview,
    withSidebar: true,
    pageTitle: "View Review",
  },
  CMSPAGE: {
    path: "/cms-pages",
    component: CMSlist,
    withSidebar: true,
    pageTitle: "CMS Pages",
  },
  ADD_CMS: {
    path: "/add-cms",
    component: CMSlist,
    withSidebar: true,
    pageTitle: "Add CMS Page",
  },
  EDIT_CMS: {
    path: "/edit-cms/:slug",
    component: CMSlist,
    withSidebar: true,
    pageTitle: "Edit CMS Page",
  },
  EDIT_HEADER: {
    path: "/edit-header/:id",
    component: EditHeader,
    withSidebar: false,
    pageTitle: "Edit Header",
  },
  EDIT_FOOTER: {
    path: "/edit-footer/:id",
    component: EditFooter,
    withSidebar: false,
    pageTitle: "Edit Footer",
  },
  EDIT_PRODUCT_PAGE: {
    path: "/edit-product-page/:id",
    component: EditProductPage,
    withSidebar: false,
    pageTitle: "Edit Product",
  },
  EDIT_CATEGORY_PAGE: {
    path: "/edit-category-page/:id",
    component: EditCategoriesPage,
    withSidebar: false,
    pageTitle: "Edit Category Page",
  },
  EDIT_PAGE: {
    path: "/edit-pages/:id",
    component: EditCMSPage,
    withSidebar: false,
    pageTitle: "Edit Pages",
  },
  EDIT_SYSTEMPAGE_PAGES: {
    path: "/edit-system-pages/:id",
    component: EditSystemPage,
    withSidebar: false,
    pageTitle: "Edit System Pages",
  },
  EDIT_CMS_BLOG_PAGES: {
    path: "/edit-blog-pages/:id",
    component: EditCMSBlogPage,
    withSidebar: false,
    pageTitle: "Edit Blog Pages",
  },
  ABANDONEDCHECKOUTS: {
    path: "/abandoned-checkouts",
    component: AbandonedCheckouts,
    withSidebar: true,
    pageTitle: "Abandoned Checkouts",
  },
  VIEW_ABANDONEDCHECKOUTS: {
    path: "/abandoned-checkouts/:id",
    component: ViewCheckout,
    withSidebar: true,
    pageTitle: "View Abandoned Checkout",
  },
  DISCOUNTS: {
    path: "/discounts",
    component: DiscountList,
    withSidebar: true,
    pageTitle: "Discounts",
  },
  ADD_DISCOUNT: {
    path: "/add-discount",
    component: DiscountAdd,
    withSidebar: true,
    pageTitle: "Add New Discount",
  },
  EDIT_DISCOUNT: {
    path: "/edit-discount/:id",
    component: DiscountEdit,
    withSidebar: true,
    pageTitle: "Edit Discount",
  },
  EDIT_STORE: {
    path: "/edit-store-address/:id",
    component: AddStore,
    withSidebar: true,
    pageTitle: "Edit Store Address",
  },
  EDIT_SHIP_STATION: {
    path: "/edit-shipping-zone",
    component: AddShipStation,
    withSidebar: true,
    pageTitle: "Edit Shipping Zone",
  },
  VENDORS: {
    path: "/vendors",
    component: Vendor,
    withSidebar: true,
    pageTitle: "Vendors",
  },
  ADD_VENDOR: {
    path: "/add-vendor",
    component: AddVendor,
    withSidebar: true,
    pageTitle: "Add Vendor",
  },
  EDIT_VENDOR: {
    path: "/edit-vendor/:id",
    component: AddVendor,
    withSidebar: true,
    pageTitle: "Edit Vendor",
  },
  VIEW_VENDOR: {
    path: "/view-vendor/:id",
    component: ViewVendor,
    withSidebar: true,
    pageTitle: "View Vendor",
  },
  SALES_TEAM: {
    path: "/sales-team",
    component: SalesTeam,
    withSidebar: true,
    pageTitle: "Sales Team",
  },
  EMAIL_TEMPLATE: {
    path: "/email-template",
    component: EmailTemplate,
    withSidebar: true,
    pageTitle: "Email Template",
  },
  ORDERS_ADDON: {
    path: "/order-addon",
    component: OrderAddOn,
    withSidebar: true,
    pageTitle: "Orders AddOn",
  },
  ADD_ORDERS_ADDON: {
    path: "/add-order-addon",
    component: AddOrderAddOn,
    withSidebar: true,
    pageTitle: "Add Orders AddOn",
  },
  EDIT_ORDERS_ADDON: {
    path: "/edit-order-addon/:id",
    component: AddOrderAddOn,
    withSidebar: true,
    pageTitle: "Edit Orders AddOn",
  },
  ADD_GIFT_CARD_PRODUCT: {
    path: "/add-gift-card-product",
    component: AddGiftCardProduct,
    withSidebar: true,
    pageTitle: "Add Gift Card Product",
  },
  EDIT_GIFT_CARD_PRODUCT: {
    path: "/edit-gift-card-product/:id",
    component: AddGiftCardProduct,
    withSidebar: true,
    pageTitle: "Edit Gift Card Product",
  },
  GIFT_CARD_LIST: {
    path: "/gift-card",
    component: GiftCardList,
    withSidebar: true,
    pageTitle: "Gift Card",
  },
  ADD_GIFT_CARD: {
    path: "/add-gift-card",
    component: AddGiftCard,
    withSidebar: true,
    pageTitle: "Add Gift Card",
  },
  VIEW_GIFT_CARD: {
    path: "/view-gift-card/:id",
    component: ViewGiftCard,
    withSidebar: true,
    pageTitle: "View Gift Card",
  },
  REPORTS: {
    path: "/reports",
    component: Reports,
    withSidebar: true,
    pageTitle: "Reports",
  },
  REPORT_COMPATBILITIY: {
    path: "/compatibility-report",
    component: CompatibilityReport,
    withSidebar: true,
    pageTitle: "Compatibility Report",
  },
  REPORT_ORDER: {
    path: "/order-report",
    component: OrderReport,
    withSidebar: true,
    pageTitle: "Order Report",
  },
  EDIT_PAYMENTS: {
    path: "/payment-gateways",
    component: EditPayments,
    withSidebar: true,
    pageTitle: "Edit Payment Gateways",
  },
  EDIT_REASONS: {
    path: "/refund-reasons",
    component: EditRefundReasons,
    withSidebar: true,
    pageTitle: "Edit Refund Reason",
  },
  VIEW_REFUNDS: {
    path: "/refunds",
    component: Refunds,
    withSidebar: true,
    pageTitle: "Refunds",
  },
  RETURN_OPERATIONS_DASHBOARD: {
    path: "/return-operations",
    component: ReturnOperationsDashboard,
    withSidebar: true,
    pageTitle: "Return Operations",
  },
  RETURN_OPERATIONS_RETURNS: {
    path: "/return-operations/returns",
    component: ReturnOperationsReturnsList,
    withSidebar: true,
    pageTitle: "Returns",
  },
  RETURN_OPERATIONS_RETURN_VIEW: {
    path: "/return-operations/returns/:id",
    component: ReturnOperationsReturnView,
    withSidebar: true,
    pageTitle: "Return Detail",
  },
  RETURN_OPERATIONS_RECEIVES: {
    path: "/return-operations/receives",
    component: ReturnOperationsReceivesList,
    withSidebar: true,
    pageTitle: "Receives",
  },
  RETURN_OPERATIONS_RECEIVE_VIEW: {
    path: "/return-operations/receives/:name",
    component: ReturnOperationsReceiveView,
    withSidebar: true,
    pageTitle: "Receive Workspace",
  },
  RETURN_OPERATIONS_REFUND_SYNC: {
    path: "/return-operations/refund-sync",
    component: ReturnOperationsRefundSyncList,
    withSidebar: true,
    pageTitle: "Refund Sync",
  },
  RETURN_OPERATIONS_REFUND_SYNC_VIEW: {
    path: "/return-operations/refund-sync/:id",
    component: ReturnOperationsRefundSyncView,
    withSidebar: true,
    pageTitle: "Refund Sync Detail",
  },
  REPAIR_ORDERS_DASHBOARD: {
    path: "/repair-orders",
    component: RepairOrdersDashboard,
    withSidebar: true,
    pageTitle: "Repair Orders",
  },
  REPAIR_ORDERS_LIST: {
    path: "/repair-orders/orders",
    component: RepairOrdersList,
    withSidebar: true,
    pageTitle: "Repair Orders List",
  },
  REPAIR_ORDERS_VIEW: {
    path: "/repair-orders/orders/:name",
    component: RepairOrderView,
    withSidebar: true,
    pageTitle: "Repair Order Detail",
  },
  REPAIR_ORDERS_INCOMING: {
    path: "/repair-orders/incoming-receives",
    component: RepairIncomingReceivesList,
    withSidebar: true,
    pageTitle: "Incoming Receives",
  },
  REPAIR_ORDERS_INCOMING_VIEW: {
    path: "/repair-orders/incoming-receives/:name",
    component: RepairIncomingReceiveView,
    withSidebar: true,
    pageTitle: "Incoming Receive Detail",
  },
  REPAIR_ORDERS_SERVICE: {
    path: "/repair-orders/service-orders",
    component: RepairServiceOrdersList,
    withSidebar: true,
    pageTitle: "Service Orders",
  },
  REPAIR_ORDERS_SERVICE_VIEW: {
    path: "/repair-orders/service-orders/:name",
    component: RepairServiceOrderView,
    withSidebar: true,
    pageTitle: "Service Order Detail",
  },
  TEST: {
    path: "/test",
    component: Test,
  },
  AFFIRM_CHECKOUT: {
    path: "/affirm-checkout",
    component: AffirmCheckout,
  },
  LOYALTY_PROGRAMS: {
    path: "/loyalty-programs",
    component: LoyaltyPrograms,
    withSidebar: true,
    pageTitle: "Loyalty Programs",
  },
  ADD_LOYALTY_PROGRAMS: {
    path: "/add-loyalty-program",
    component: AddLoyaltyProgram,
    withSidebar: true,
    pageTitle: "Add Loyalty Program",
  },
  EDIT_LOYALTY_PROGRAMS: {
    path: "/edit-loyalty-program/:id",
    component: AddLoyaltyProgram,
    withSidebar: true,
    pageTitle: "Edit Loyalty Program",
  },
  ADD_LOYALTY_PROMOTION: {
    path: "/add-loyalty-promotion",
    component: AddLoyaltyPromotion,
    withSidebar: true,
    pageTitle: "Add Loyalty Promotion",
  },
  EDIT_LOYALTY_PROMOTION: {
    path: "/edit-loyalty-promotion/:id",
    component: AddLoyaltyPromotion,
    withSidebar: true,
    pageTitle: "Edit Loyalty Promotion",
  },
};

export default routes;
